module.exports = __webpack_public_path__ + "img/web1.c71c9fce.png";